import { render } from "./UserInfoPanel.vue?vue&type=template&id=1a0e16b2&scoped=true"
import script from "./UserInfoPanel.vue?vue&type=script&lang=js"
export * from "./UserInfoPanel.vue?vue&type=script&lang=js"

import "./UserInfoPanel.vue?vue&type=style&index=0&id=1a0e16b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0e16b2"]])

export default __exports__